import { Result } from '@standardnotes/domain-core';
export class GetKeyPairs {
    constructor(rootKeyManager) {
        this.rootKeyManager = rootKeyManager;
    }
    execute() {
        const rootKey = this.rootKeyManager.getRootKey();
        if (!(rootKey === null || rootKey === void 0 ? void 0 : rootKey.encryptionKeyPair) || !(rootKey === null || rootKey === void 0 ? void 0 : rootKey.signingKeyPair)) {
            return Result.fail('Account keypair not found');
        }
        return Result.ok({
            encryption: rootKey.encryptionKeyPair,
            signing: rootKey.signingKeyPair,
        });
    }
}
